/** Highlights every word of the search query inside a text string. */
export const HighlightText = ({ text, query, className = '' }) => {
  const value = text == null ? '' : String(text);
  // 1-char words are skipped - highlighting them makes the result unreadable
  const tokens = (query || '').trim().split(/\s+/).filter(t => t.length > 1);

  if (tokens.length === 0) return <span className={className}>{value}</span>;

  const escaped = tokens.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const parts = value.split(new RegExp(`(${escaped.join('|')})`, 'gi'));
  const lowered = escaped.map(t => t.toLowerCase());

  return (
    <span className={className}>
      {parts.map((part, i) =>
        lowered.includes(part.toLowerCase()) ? (
          <mark key={i} className="bg-amber-200/80 text-gray-900 rounded px-0.5">{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  );
};

export default HighlightText;
